import { autoinject, bindable, observable } from 'aurelia-framework';
import { IAccountingRule, IAccountingRuleFolder, RuleTemplate } from './accounting-rule-models';

interface ICostCenterAutoComplete {
	id: string;
	specifier: string;
	name: string;
}

@autoinject
export class AddAccountingRule {
	@bindable scopeId: string;
	@bindable scopeIsClosed: boolean;
	@bindable fiscalYearId: string;
	@bindable insertSuccessCallback: (rule: IAccountingRule) => void;
	@bindable allowAddingAutomaticTypeRecognitionRule: boolean;
	
	@bindable folders: IAccountingRuleFolder[];

	@observable newRuleType: string;
	@observable newRuleAllCostCenters: boolean;

	newRuleCostCenterId: string;
	newRuleDefinition: string;
	selectedCostCenter: ICostCenterAutoComplete;

	generateTemplate() {
		this.newRuleDefinition = this.getDefinitionTemplate();
	}

	ruleAdded(addedRule: IAccountingRule) {
		if (this.insertSuccessCallback) {
			this.insertSuccessCallback(addedRule);
		}
	}

	newRuleTypeChanged() {
		if (this.newRuleType === 'AutomaticTypeRecognition') {
			this.newRuleAllCostCenters = true;
		}
		this.generateTemplate();
	}

	costCenterSelected(item: ICostCenterAutoComplete) {
		this.selectedCostCenter = item;
		this.generateTemplate();
	}

	newRuleAllCostCentersChanged(newValue: boolean, oldValue: boolean) {
		if (newValue == null) {
			return;
		}

		if (newValue === true) {
			this.selectedCostCenter = null;
			this.newRuleCostCenterId = null;
		}

		this.generateTemplate();
	}

	attached() {
		this.resetForm();
	}

	resetForm() {
		this.newRuleAllCostCenters = false;
		this.newRuleCostCenterId = null;
		this.selectedCostCenter = null;
		this.newRuleType = 'CostCenterDivision';
	}

	private getDefinitionTemplate() {
		let result = RuleTemplate.getForType(this.newRuleType)
			.replace('<MUNICIPALITIES>', '    ')
			.replace('<SERVICES>', '    ');

		if (this.selectedCostCenter) {
			result = result.replace('<COSTCENTER>', `costcenter ${this.selectedCostCenter.specifier}`);
		}

		if (this.newRuleAllCostCenters) {
			result = result.replace('<COSTCENTER>', 'all costcenters');
		}

		return result;
	}
}
